import { LinearProgress, Stack } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { styled } from '@mui/material/styles';
import * as React from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { AppState, store, useAppSelector } from 'src/store';
import { setDocumentDetail } from 'src/store/documentDetail';
import { setSnackbarMessage } from 'src/store/snackbarMessage';
import { SelectSubartifact } from './SelectSubartifact';
import DocManagementService from './service/DocManagementService';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}));

export interface ISubartifactVersions {
  document_id: string;
  tmf_document_id: string;
  tmf_document_name: string;
  tmf_doc_version_number: number;
  tmf_doc_type: string;
  tmf_doc_subtype: string;
  tmf_artifact_number: string;
  tmf_artifact_name: string;
  tmf_doc_level: string;
  tmf_doc_study: string;
  tmf_doc_country: string;
  tmf_doc_site: string;
  tmf_doc_status: string;
}

export const VersionControl = ({
  metaData,
  handleCloseVersion,
  resData,
  selectData,
  docViewer,
  editedFmID,
  setOpenVersion,
  documentValue,
  ClearData,
  setUploaded,
  setStyleUpload,
  setFileUploaded,
  setDocUploadComponent,
  setOpenEditDocVersion
}: any) => {
  const [versionNumber, setVersionNumber] = useState(``);
  const docService = new DocManagementService();
  const [openSubArtifact, setOpenSubArtifact] = useState<boolean>(false);
  const documentDetail: any = useSelector((state: AppState) => state.documentDetail);
  const [subArtifactVersions, setSubArtifactVersions] = useState<ISubartifactVersions[]>([]);
  const SearchHierarchyDetail: any = useSelector((state: AppState) => state.searchHierarchyDetails);
  const [search, setSearch] = useState({
    Study: SearchHierarchyDetail?.data[0]?.Study,
    Country: SearchHierarchyDetail?.data[0]?.Country,
    Site: SearchHierarchyDetail?.data[0]?.Site
  });
  let tmfLvel: any, tmfStudy: any, tmfArtifactName: any;
  if (docViewer) {
    tmfLvel = selectData.tmf_doc_level;
    tmfStudy = selectData.tmf_doc_study;
    tmfArtifactName = selectData.tmf_artifact_name;
  } else {
    tmfLvel = selectData.document_data.tmf_doc_level;
    tmfStudy = selectData.document_data.tmf_doc_study;
    tmfArtifactName = selectData.document_data.tmf_artifact_name;
  }
  const selectedStudy = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Study);
  const selectedCountry = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Country);
  const selectedSite = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Site);
  const dispatch = useDispatch();

  let TmfLevel =
    (selectedStudy === '--' || selectedStudy === '') &&
    (selectedCountry === '--' || selectedCountry == '') &&
    (selectedSite === '--' || selectedSite === '')
      ? '--'
      : (selectedCountry === '--' || selectedCountry == '') && (selectedSite === '--' || selectedSite === '')
      ? 'Study'
      : selectedSite === '--' && selectedCountry != '--'
      ? 'Country'
      : 'Site';
  if (TmfLevel === '--') {
    TmfLevel = 'Study';
  }

  const user: any = useAppSelector(state => state.user.user);
  const userName = `${user.firstName + ' ' + user.lastName}`;
  const [isProcessing, setProcessing] = useState(false);

  const handleVersionChange = (e: any) => {
    const value = e.target.value;
    setVersionNumber(value);
  };

  const addSubartifactData = async (subartifactDocData: any) => {
    const params = {
      module_section_related: 'DocumentDetails',
      parent_entity_related: metaData.tmf_document_name
    };
    const res: any = await docService.createMasterDocument(params, subartifactDocData);
    if (res.error) {
      store.dispatch(setSnackbarMessage('Error in uploading document.', 'error'));
    } else {
      store.dispatch(setSnackbarMessage('Document is uploaded successfully.', 'success'));
      documentValue();
    }
  };

  const getSubArtifactVersionDetails = async (tmfLvel: any, tmfStudy: any, tmfArtifactName: any) => {
    setProcessing(true);
    const params = {
      module_section_related: 'DocumentDetails',
      parent_entity_related: metaData.tmf_document_name
    };
    const res: any = await docService.getSubArtifactVersionDetails(
      tmfLvel,
      tmfStudy,
      metaData.tmf_doc_country ? metaData.tmf_doc_country : '--',
      metaData.tmf_doc_site ? metaData.tmf_doc_site : '--',
      tmfArtifactName,
      params
    );
    setProcessing(false);
    if (res.data) {
      setSubArtifactVersions(res.data);
      setOpenSubArtifact(true);
    } else if (res.error) {
      store.dispatch(setSnackbarMessage('Error in getting subartifacts version details.', 'error'));
    }
  };

  const handleUpdatedDocument = (Meta: any, Res: any, metaData: any) => {
    if (versionNumber === 'subartifact') {
      const subartifactDocData: any = {
        file_master_id: Res.id,
        document_data: {
          tmf_artifact_number: Meta.document_data.tmf_artifact_number,
          tmf_document_name: metaData.tmf_document_name,
          tmf_doc_type: metaData?.tmf_document_type,
          tmf_doc_subtype: metaData?.tmf_document_subtype,
          tmf_doc_viewer_req_certified_copy: 'N',
          tmf_doc_status: 'Uploaded',
          tmf_doc_country:
            Meta.document_data.tmf_doc_level === 'Country' || Meta.document_data.tmf_doc_level === 'Site'
              ? Meta.document_data.tmf_doc_country
              : null,
          tmf_doc_study: Meta.document_data.tmf_doc_study,
          tmf_doc_site: Meta.document_data.tmf_doc_level === 'Site' ? Meta.document_data.tmf_doc_site : null,
          tmf_doc_viewer_department: 'None',
          tmf_doc_viewer_language: 'English',
          tmf_doc_viewer_approval_cycle: 0,
          tmf_doc_viewer_product_detail: 'test1',
          tmf_doc_viewer_ref_model_version: 'TMF RM 3.2.1',
          tmf_doc_viewer_format: Res.tmf_doc_type,
          tmf_doc_viewer_inspection_ready: '',
          tmf_doc_viewer_ir_issue_type: '',
          tmf_doc_level: Meta.document_data.tmf_doc_level,
          tmf_artifact_name: Meta.document_data.tmf_artifact_name,
          tmf_doc_version_number: '1.0',
          tmf_doc_milestone: Meta.document_data.tmf_doc_milestone,
          tmf_document_id: 'str',
          tmf_doc_created_by: userName
        }
      };
      addSubartifactData(subartifactDocData);
      handleCloseVersion();
      setStyleUpload('uploadFile');
      setFileUploaded(null);
      setUploaded(false);
      ClearData();
      setDocUploadComponent(true);
    } else if (versionNumber === 'Major' || versionNumber === 'Minor' || versionNumber === 'Overwrite') {
      if (!docViewer) {
        getSubArtifactVersionDetails(tmfLvel, tmfStudy, tmfArtifactName);
      } else {
        updateDocumentVersionData(Meta);
      }
    }
  };
  const updateDocumentVersionData = (Meta: any) => {
    const docStatus = Meta.tmf_doc_status === 'Approved' ? 'Uploaded' : Meta.tmf_doc_status;

    const certifiedCopy = Meta.tmf_doc_status === 'Approved' ? 'N' : Meta.tmf_doc_viewer_req_certified_copy;

    const subartifactUpdateObj = {
      file_master_id: editedFmID,
      document_data: {
        tmf_artifact_number: Meta.tmf_artifact_number,
        tmf_document_name: Meta.tmf_document_name,
        tmf_doc_type: Meta.tmf_doc_type,
        tmf_doc_subtype: Meta.tmf_doc_subtype,
        tmf_doc_viewer_req_certified_copy: certifiedCopy,
        tmf_doc_status: docStatus,
        tmf_doc_country: Meta.tmf_doc_country,
        tmf_doc_study: Meta.tmf_doc_study,
        tmf_doc_site: Meta.tmf_doc_site,
        tmf_doc_viewer_department: Meta.tmf_doc_viewer_department,
        tmf_doc_viewer_language: Meta.tmf_doc_viewer_language,
        tmf_doc_viewer_approval_cycle: Meta.tmf_doc_viewer_approval_cycle,
        tmf_doc_viewer_product_detail: Meta.tmf_doc_viewer_product_detail,
        tmf_doc_viewer_ref_model_version: Meta.tmf_doc_viewer_ref_model_version,
        tmf_doc_viewer_format: Meta.tmf_doc_viewer_format,
        tmf_doc_viewer_inspection_ready: Meta.tmf_doc_viewer_inspection_ready,
        tmf_doc_viewer_ir_issue_type: Meta.tmf_doc_viewer_ir_issue_type,
        tmf_doc_level: Meta.tmf_doc_level,
        tmf_artifact_name: Meta.tmf_artifact_name,
        tmf_doc_version_number: Meta.tmf_doc_version_number,
        tmf_doc_milestone: Meta.tmf_doc_milestone,
        tmf_document_id: Meta.tmf_document_id,
        id: Meta.id,
        tmf_doc_last_modified_by: userName
      }
    };
    versionNumber === 'Major' || versionNumber === 'Minor'
      ? updatedVersionData(
          {
            ...subartifactUpdateObj,
            tmf_doc_new_version_number:
              versionNumber === 'Major'
                ? Math.floor(Meta.tmf_doc_version_number + 1.0).toFixed(1)
                : (Meta.tmf_doc_version_number + 0.1).toFixed(1)
          },
          Meta
        )
      : overwriteVersionData(subartifactUpdateObj, Meta);
  };

  const updatedVersionData = async (docData: any, docDetails: any) => {
    let qcResponse;
    if (docDetails.tmf_doc_status === 'Approved') {
      qcResponse = await getQcDetails(docDetails);
    }

    const params = {
      module_section_related: 'DocumentDetails',
      parent_entity_related: docDetails.tmf_document_name
    };

    const res = await docService.updatedVersionData(params, docData);
    if (res.data) {
      setDocumentDetail(dispatch, [
        {
          ...documentDetail.data[0],
          fileId: res.data.file_master_id,
          tmf_doc_version_number: docData.tmf_doc_new_version_number,
          tmf_doc_status: res.data.document_data.tmf_doc_status,
          tmf_doc_viewer_req_certified_copy: res.data.tmf_doc_viewer_req_certified_copy,
          is_checkbox_verified: qcResponse?.data?.is_checkbox_verified,
          id: res.data.document_data.id
        }
      ]);
      store.dispatch(setSnackbarMessage('Document is updated successfully.', 'success'));
      handleCloseVersion();
    } else {
      store.dispatch(setSnackbarMessage('Error in updating document.', 'error'));
    }
  };

  const overwriteVersionData = async (overwriteDocData: any, docDetails: any) => {
    let qcResponse;
    if (docDetails.tmf_doc_status === 'Approved') {
      qcResponse = await getQcDetails(docDetails);
    }
    const params = {
      module_section_related: 'DocumentDetails',
      parent_entity_related: docDetails.tmf_document_name
    };
    const res = await docService.updateMasterDocument(params, overwriteDocData);
    if (res.data) {
      setDocumentDetail(dispatch, [
        {
          ...documentDetail.data[0],
          fileId: res.data.file_master_id,
          tmf_doc_status: res.data.document_data.tmf_doc_status,
          tmf_doc_viewer_req_certified_copy: res.data.tmf_doc_viewer_req_certified_copy,
          is_checkbox_verified: qcResponse?.data?.is_checkbox_verified,
          id: res.data.document_data.id
        }
      ]);
      store.dispatch(setSnackbarMessage('Document is updated successfully.', 'success'));
      handleCloseVersion();
    } else {
      store.dispatch(setSnackbarMessage('Error in updating document.', 'error'));
    }
  };

  const getQcDetails = async (docDetails: any) => {
    const qcParams = {
      module_section_related: 'DocumentQCControl',
      parent_entity_related: docDetails.tmf_document_name
    };
    const result: any = await docService.getQualityControlDetailsById(
      docDetails.id,
      selectedStudy,
      selectedCountry,
      selectedSite,
      docDetails.tmf_doc_level,
      qcParams
    );
    const qualityControl = result?.data?.quality_control;
    const UpdatedQCData: any = {
      tmf_doc_viewer_req_certified_copy: 'N',
      tmf_doc_viewer_qc_issue_type: qualityControl?.tmf_doc_viewer_qc_issue_type,
      tmf_doc_viewer_qc_issue_comments: qualityControl?.tmf_doc_viewer_qc_issue_comments,
      id: qualityControl?.id,
      is_checkbox_verified: false,
      updated_by: userName
    };
    const qcResponse = await docService.updateQC(
      qcParams,
      UpdatedQCData,
      TmfLevel,
      selectedStudy,
      selectedCountry,
      selectedSite
    );
    return qcResponse;
  };

  return (
    <div className="versionControl-modal">
      <React.Fragment>
        <DialogContent dividers className="quallityControl-modalcontent version-control-modalcontent">
          <h3> Update Artifact </h3>
          <Grid container>
            <Grid md={12}>
              <p>{`${tmfArtifactName}`} artifact already exists. How would you like to make updates?</p>
            </Grid>

            <Grid md={12}>
              {isProcessing && <LinearProgress />}
              <FormControl className="radio-section">
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="radio-buttons-group"
                  defaultValue={versionNumber}
                  onChange={handleVersionChange}
                >
                  <FormControlLabel
                    value={`Major`}
                    control={<Radio />}
                    label={`Update as major change (ex. Version 1.0 → 2.0)`}
                  />
                  <FormControlLabel
                    value={`Minor`}
                    control={<Radio />}
                    label={`Update as minor change (ex. Version 1.0 → 1.1)`}
                  />
                  <FormControlLabel value={`Overwrite`} control={<Radio />} label="Overwrite current version" />
                  {!docViewer && (
                    <FormControlLabel value={'subartifact'} control={<Radio />} label="Upload as a new subartifact" />
                  )}
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item md={12} className="button-actions">
              <Grid container spacing={2}>
                <Grid item md={12} display="flex" justifyContent="flex-end">
                  <Stack direction="row" spacing={2}>
                    <Button className="grey-btn" onClick={handleCloseVersion}>
                      Close
                    </Button>
                    <Button
                      onClick={() => handleUpdatedDocument(selectData, resData, metaData)}
                      disabled={!versionNumber}
                    >
                      Save
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </React.Fragment>
      <React.Fragment>
        <PopupComponent maxWidth="sm" open={openSubArtifact}>
          <SelectSubartifact
            setDocUploadComponent={setDocUploadComponent}
            setOpenSubArtifact={setOpenSubArtifact}
            versionNumber={versionNumber}
            subArtifactVersions={subArtifactVersions}
            handleCloseVersion={handleCloseVersion}
            resData={resData}
            metaData={metaData}
            documentValue={documentValue}
            setStyleUpload={setStyleUpload}
            setUploaded={setUploaded}
            ClearData={ClearData}
            setFileUploadec={setFileUploaded}
            setOpenVersion={setOpenVersion}
          />
        </PopupComponent>
      </React.Fragment>
    </div>
  );
};
